import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";
import { getOutlookToken } from "../office";

const API_URL = import.meta.env.VITE_GRAPHQL_URL ?? "https://localhost:5001/graphql";

let client: ApolloClient | null = null;

const httpLink = createHttpLink({
  uri: API_URL,
});

const authLink = new SetContextLink(async (prevContext) => {
  const token = await getOutlookToken();
  return {
    headers: {
      ...prevContext.headers,
      authorization: `Bearer ${token}`,
    },
  };
});

export function initializeGraphql(): void {
  client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: { fetchPolicy: "cache-and-network" },
    },
  });
}

export function getClient(): ApolloClient {
  if (!client) {
    throw new Error("Apollo client not initialized. Call initializeGraphql() first.");
  }
  return client;
}
